import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Loader from "common/components/Loader";
import WorkspaceInvitation from "common/components/WorkspaceInvitation";
import useInvitations from "common/datahooks/useInvitations";
import useGTM from "common/hooks/useGTM";

import Header from "./Header";
import Questionnaire from "./Questionnaire";

export default function Onboarding() {
  const { sendEvent } = useGTM();
  const location = useLocation();
  const { invitations, isLoadingInvitations } = useInvitations();

  const [onboardingId, setOnboardingId] = useState<
    "questionnaire" | "invitation"
  >();

  useEffect(() => {
    sendEvent("virtualPageView", () => ({
      pageUrl: window.location.href,
      pagePath: location.pathname,
    }));
  }, []);

  useEffect(() => {
    if (!isLoadingInvitations) {
      if (invitations?.length > 0) {
        setOnboardingId("invitation");
      } else {
        setOnboardingId("questionnaire");
      }
    }
  }, [isLoadingInvitations]);

  let mainComponent = <Loader />;
  if (onboardingId === "invitation") {
    mainComponent = (
      <WorkspaceInvitation
        invitation={invitations?.[0]}
        onDecline={() => setOnboardingId("questionnaire")}
      />
    );
  } else if (onboardingId === "questionnaire") {
    mainComponent = <Questionnaire />;
  }

  return (
    <>
      <Header
        onboardingId={onboardingId}
        onBack={() => setOnboardingId("questionnaire")}
      />

      <main className="bg-white relative mx-auto flex min-h-[calc(100dvh_-_80px)] grow flex-col items-center justify-center px-4 py-6 lg:py-12">
        {mainComponent}
      </main>
    </>
  );
}
